<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1450px'"
    :classDialog="'dialog-doc-out-finish'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <el-row :gutter="12" class="">
        <el-col :span="5" class="pListThumb">
          <div class="pListThumb-Title margin-top-10">
            <h2 class="margin-botom-10 margin-top-10">
              Ký ban hành {{ vbName }}
            </h2>
          </div>
          <VuePerfectScrollbar :class="['pScroll']">
            <p-thumbnail
              v-for="(item, $itemIndex) in listImages"
              :key="`page_${$itemIndex}`"
              :url="item.url"
              :title="`Trang ${$itemIndex + 1}`"
              :active="urlDocSelected === item"
              :isModify="item.isModify"
              @click="changeSelectedDoc(item, $itemIndex, false)"
            ></p-thumbnail>
          </VuePerfectScrollbar>
        </el-col>
        <el-col :span="14" class="pDetailDocs">
          <detail-docs-v2
            v-if="listImages && listImages.length"
            ref="detailDoc"
            :docCode="docCode"
            :docDate="docDate"
            :isLoading="isChangingSelectedDoc"
          ></detail-docs-v2>
        </el-col>
        <el-col :span="5" class="pListThumb">
          <VuePerfectScrollbar :class="['pScroll scrollSignature']">
            <div class="pListThumb-Title">
              <div
                class="pListThumb-Title"
                v-if="textImages && textImages.length"
              >
                <h2 class="">
                  {{ "Thông tin văn bản" }}
                </h2>
              </div>
              <pImage
                v-for="(item, $index) in textImages"
                :key="item.id"
                :text="item.value"
                :type="item.type"
                :_idCanvas="$index"
                :title="getPImageTitle(item)"
                :fontConfig="item.fontConfig"
                :urlImageDau="listStamp &&  listStamp.length ? listStamp[0].url : '' "
                @addDateTimeImg="(urlImg,codau) => addDateTimeImg({urlImg,codau}, item)"
              />
            </div>
            <div
              class="pListThumb-Title"
              v-if="listSignature && listSignature.length"
            >
              <h2 class="">
                {{ "Danh sách chữ ký" }}
              </h2>
            </div>

            <p-thumbnail
              v-for="(item, $itemIndex) in listSignature"
              :key="`signature_${$itemIndex}`"
              :url="item.url"
              :title="item.userDeptRoleView.fullName"
              @click="
                addImageSignature(item, DETAIL_DOCS_PAGE.SHAPE_TYPE.CHU_KY)
              "
            ></p-thumbnail>
            <img style="display:none;" id = "imgChuKy" />
            <div class="pListThumb-Title" v-if="listStamp && listStamp.length">
              <h2 class="margin-botom-10 margin-top-10">
                {{ "Danh sách con dấu" }}
              </h2>
            </div>

            <p-thumbnail
              v-for="(item, $index) in listStamp"
              :key="`stamp_${$index}`"
              :url="item.url"
              :title="item.department.deptName"
              @click="addImageStamp(item, DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU)"
            ></p-thumbnail>

            <div class="pListThumb-Title">
              <h2 class="margin-botom-10 margin-top-10">
                {{ "Logo" }}
              </h2>
            </div>
            <p-thumbnail
              :url="tenantImgUrl"
              :title="Logo"
              @click="addLogo({ url: tenantImgUrl }, DETAIL_DOCS_PAGE.SHAPE_TYPE.LOGO)"
            ></p-thumbnail>

            <div v-if="isDisplayQrCode">
              <div class="pListThumb-Title">
                <h2 class="margin-botom-10 margin-top-10">
                  {{ "QR Mẫu giới thiệu" }}
                </h2>
              </div>
              <div style="display: flex" @click="addQRCodeSignature" >
                <qrcode-vue ref="qrCode" :value="valueQrCode" :size="size" level="H" />
              </div>
            </div>
          </VuePerfectScrollbar>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row flex__left form-button__action">
        <div>
          <el-button
            class="dialogBtnSecondary"
            @click="submitTest"
            :disabled="isProcessing || isSubmitting || isChangingSelectedDoc"
          >
            <span class="flex-row flex__center">
              <i
                :class="[
                  !isProcessing && !isSubmitting
                    ? 'fas fa-save'
                    : 'el-icon-loading'
                ]"
              ></i>
              &nbsp;Xác nhận
            </span>
          </el-button>
        </div>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
  import constants from "../../../constants";
  import buildAttachmentURL from "../../../filters/buildAttachmentURL";
  import buildAttachmentImage from "../../../filters/buildAttachmentImage";
  import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
  import attachmentService from "../../../services/attachmentService";
  import {TYPE_LIST} from "./const-shape.js";
  import vbFlowInstanceService from "../../../services/vbFlowInstanceService";
  import PThumbnail from "./p-thumbnail";
  import h from "../../../services/h";
  import dateUtils from "../../../dateUtils";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import uuidv4 from "uuid/v4";
  import DetailDocsV2 from "./detail-docs-v2";
  import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
  import utils from "../../../services/utils";
  import QrcodeVue from 'qrcode.vue'
  import axios from "axios";
  export default {
    name: "ky-token-dialog",
    props: [
      "isOpen",
      "vbAttachmentId",
      "docId",
      "docDate",
      "docCode",
      "publisherDept",
      "signDate",
      "isProcessing",
      "isKyNgoai",
      "needToSignCa",
      "relationDocId",
      "attachedType",
      "nextRelationDoc",
      "isSignOriginalDoc",
      "isAddIssuedBookNumber"
    ],
    filters: {buildAttachmentURL, buildAttachmentImage},

    components: {
      DetailDocsV2,
      PThumbnail,
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
      dialogTemplate: () => import("../custom-dialog"),
      pThumb: () => import("./p-thumbnail"),
      pImage: () => import("./pImage.vue"),
      detailDocs: () => import("./detailDocsNew.vue"),
      QrcodeVue
    },
    data() {
      return {
        valueQrCode: null,
        size: 200,
        type: {
          thumb: TYPE_LIST.THUMB,
          sign: TYPE_LIST.SIGNATURE
        },
        checkBanHanhKem: false,
        vbName: "",
        token: null,
        listImages: [],
        urlDocSelected: null,
        listSignature: [],
        listStamp: [],
        listAttachment: [],
        flowInstanceId: null,
        trangKySo: null,
        textImages: [],
        DETAIL_DOCS_PAGE: constants.DETAIL_DOCS_PAGE,
        shapeType: null,
        vbOutgoingProcesses: null, //danh sach cac node chuyen co thuc hien ky so;
        selectedPageIndex: null,
        pagesData: [],
        isSubmitting: false,
        isChangingSelectedDoc: false,
        pageSize: 0,
        logo: {
          url: this.tenantImgUrl
        }
      };
    },

    computed: {
      isDisplayQrCode() {
        return this.$store.getters.userDeptRole.tenantCode === 'thanhtra.com.vn'
      },

      tenantImgUrl () {
        return constants.SMART_OFFICE_IMAGE_URL + 'logo/' + this.$store.getters.tenantLogoUrl;
      },
      roleCode() {
        return this.$store.getters.userDeptRole.roleCode;
      },

      isShouldToInsertLanhDaoNotes() {
        //neu trong van ban co y kien chi dao cua lanh dao cua don vi cha don vi ban hanh >
        // thuc hien chen y kien lanh dao vao file ky so;
        return h.exists(
          this.vbOutgoingProcesses,
          vbOutgoingProcess =>
            vbOutgoingProcess.note &&
            vbOutgoingProcess.deptReceiverId === this.publisherDept.parentId
        );
      },
      // check tenant_code = vinataba
      isVinataba() {
        return this.$store.getters.userDeptRole.tenantCode === constants.TENANT_CODE.VINATABA;
      },
    },

    watch: {
      relationDocId: function(newValue, oldValue) {
        this.checkBanHanhKem = this.attachedType === constants.DOC_RELATION_ATTACHED_TYPE.ATTACHED;
        this.vbName = this.isSignOriginalDoc ? 'văn bản chính' : (this.checkBanHanhKem ? 'văn bản đính kèm' : 'văn bản không ban hành kèm')
        if (this.isKyNgoai) {
          this.initTextImages();
        } else {
          this.loadVbFlowInstance()
            .then(() => this.generateTokenSignature())
            .then(() => this.getListSignatureImage())
            .then(() => this.generateTokenStamp())
            .then(() => this.getListStampImage())
            .then(() => this.findNotesForBanHanh())
            .then(() => this.initTextImages());
        }
        this.initToken();
      },
    },

    created() {
      this.checkBanHanhKem = this.attachedType === constants.DOC_RELATION_ATTACHED_TYPE.ATTACHED;
      this.vbName = this.isSignOriginalDoc ? 'văn bản chính' : (this.checkBanHanhKem ? 'văn bản đính kèm' : 'văn bản không ban hành kèm')
      if (this.isKyNgoai) {
        if(this.$store.getters.userDeptRole.tenantCode === 'vinataba.com.vn') {
          this.generateTokenSignature()
            .then(() => this.getListSignatureImage())
            .then(() => this.generateTokenStamp())
            .then(() => this.getListStampImage())
            .then(() => this.findNotesForBanHanh())
            .then(() => this.initTextImages());
        }
        else {
          this.initTextImages();
        }
      } else {
        this.loadVbFlowInstance()
          .then(() => this.generateTokenSignature())
          .then(() => this.getListSignatureImage())
          .then(() => this.generateTokenStamp())
          .then(() => this.getListStampImage())
          .then(() => this.findNotesForBanHanh())
          .then(() => this.initTextImages());
      }
      this.initToken();
      this.getTokenOutgoingDoc()
    },

    methods: {
      resetPagesData() {
        this.pagesData = [];
      },

      // lay danh sach chi dao;
      findNotesForBanHanh() {
        return vbOutgoingProcessService
          .findNotesForBanHanh(this.docId, this.flowInstanceId)
          .then(response => (this.vbOutgoingProcesses = response.data));
      },

      getPImageTitle(textImage) {
        switch (textImage.type) {
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO:
            return errorMessageFilter({
              errorCode: "signToken.publisherInfo.title"
            });
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.KY_CO_DAU:
            return errorMessageFilter({errorCode: "signToken.kyCoDau.title"});
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE:
            return errorMessageFilter({errorCode: "signToken.docCode.title"});
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC:
            return errorMessageFilter({errorCode: "signToken.phuLuc.title"});
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE:
            return errorMessageFilter({errorCode: "signToken.docDate.title"});
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.CHI_DAO:
            return errorMessageFilter({
              errorCode: "signToken.chiDao.title",
              params: [textImage.data.vbOutgoingProcess.receiverName]
            });
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_Y:
            return errorMessageFilter({errorCode: "signToken.saoY.title"});
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_LUC:
            return errorMessageFilter({errorCode: "signToken.saoLuc.title"});
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.TRICH_SAO:
            return errorMessageFilter({errorCode: "signToken.trichSao.title"});
          default:
            return "";
        }
      },

      initTextImages() {
        let docDate_ = dateUtils.toMoment(this.docDate);
        let now_ = dateUtils.toMoment(this.signDate.getTime());

        this.textImages = [];

        if(this.isSignOriginalDoc) {
          this.textImages.push({
            id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE,
            type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE,
            value: errorMessageFilter({
              errorCode: "signToken.docCode",
              params: [this.docCode]
            }),
            fontConfig: {
              fontStyle: "normal",
              additionalWidth: 50,
              minLength: 200
            }
          });

          this.textImages.push({
            id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
            type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
            value: utils.convertDateTime(docDate_),
            fontConfig: {additionalWidth: 100}
          });
        }

        this.textImages.push({
          id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC,
          type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC,
          value: errorMessageFilter({
            errorCode: "signToken.phuLuc",
            params: [
              this.docCode,
              utils.convertDateTime(docDate_),
              // this.isAddIssuedBookNumber ?
              //   docDate_.format("DD/MM/YYYY; ") + now_.format("HH:mm:ss")
              //   : now_.format("DD/MM/YYYY; HH:mm:ss")
            ]
          }),
          fontConfig: {additionalWidth: 100}
        });

        // Neu la ky ngoai thi co them Sao Y, Sao Luc, Trich Sao
        if (this.isKyNgoai) {
          this.textImages.push({
            id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_Y,
            type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_Y,
            value: errorMessageFilter({
              errorCode: "signToken.saoY",
              params: [
                this.publisherDept.deptName,
                // now_.format("DD/MM/YYYY; HH:mm:ss")
                this.isAddIssuedBookNumber ?
                  docDate_.format("DD/MM/YYYY; ") + now_.format("HH:mm:ss")
                  : now_.format("DD/MM/YYYY; HH:mm:ss")
              ]
            }),
            fontConfig: {
              fontStyle: "normal",
              fontColor: "blue",
              additionalWidth: 0
            }
          });
          this.textImages.push({
            id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_LUC,
            type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_LUC,
            value: errorMessageFilter({
              errorCode: "signToken.saoLuc",
              params: [
                this.publisherDept.deptName,
                // now_.format("DD/MM/YYYY; HH:mm:ss")
                this.isAddIssuedBookNumber ?
                  docDate_.format("DD/MM/YYYY; ") + now_.format("HH:mm:ss")
                  : now_.format("DD/MM/YYYY; HH:mm:ss")
              ]
            }),
            fontConfig: {
              fontStyle: "normal",
              fontColor: "blue",
              additionalWidth: 0
            }
          });
          this.textImages.push({
            id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.TRICH_SAO,
            type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.TRICH_SAO,
            value: errorMessageFilter({
              errorCode: "signToken.trichSao",
              params: [
                this.publisherDept.deptName,
                // now_.format("DD/MM/YYYY; HH:mm:ss")
                this.isAddIssuedBookNumber ?
                  docDate_.format("DD/MM/YYYY; ") + now_.format("HH:mm:ss")
                  : now_.format("DD/MM/YYYY; HH:mm:ss")
              ]
            }),
            fontConfig: {
              fontStyle: "normal",
              fontColor: "blue",
              additionalWidth: 0
            }
          });
        }

        if(this.isSignOriginalDoc) {
          h.each(this.vbOutgoingProcesses, vbOutgoingProcess => {
            this.textImages.push({
              id: uuidv4(),
              type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.CHI_DAO,
              value: errorMessageFilter({
                errorCode: "signToken.chiDao",
                params: [vbOutgoingProcess.note]
              }),
              fontConfig: {
                fontStyle: "normal",
                fontColor: "blue",
                additionalWidth: 0
              },
              data: {
                vbOutgoingProcess: vbOutgoingProcess
              }
            });
          });
        }

        this.textImages.push({
          id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO,
          type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO,
          value: errorMessageFilter({
            errorCode: "signToken.publisherInfo",
            params: [
              this.publisherDept.deptName,
              // now_.format("DD/MM/YYYY; HH:mm:ss")
              this.isAddIssuedBookNumber ?
                docDate_.format("DD/MM/YYYY; ") + now_.format("HH:mm:ss")
                : now_.format("DD/MM/YYYY; HH:mm:ss")
            ]
          }),
          fontConfig: {
            fontStyle: "normal",
            fontColor: "blue",
            additionalWidth: 0
          }
        });
        //nếu có con dấu thì hiển thị phần này & tenant = vinataba
        if (typeof this.listStamp !== 'undefined' && this.listStamp.length > 0 && this.isVinataba){
          this.textImages.push({
            id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.KY_CO_DAU,
            type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.KY_CO_DAU,
            value: errorMessageFilter({
              errorCode: "signToken.kyCoDau",
              params: [
                this.publisherDept.deptName,
                this.isAddIssuedBookNumber ?
                  docDate_.format("DD/MM/YYYY; ") + now_.format("HH:mm:ss")
                  : now_.format("DD/MM/YYYY; HH:mm:ss")
              ]
            }),
            fontConfig: {
              fontStyle: "normal",
              fontColor: "blue",
              additionalWidth: 0
            }
          });
        }
      },

      addDateTimeImg(configImg, textImage) {
        if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc) return;
        let shapeType;
        let defaultWidth;
        let fontSize;
        let fontStyle;
        let fill;
        let addWhiteBackground = true;
        switch (textImage.type) {
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.PUBLISHER_INFO;
            fontSize =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_SIZE_VB_DEN;
            defaultWidth =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PUBLISHER_INFO_WIDTH;
            fill = `${constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PUBLISHER_INFO_FILL},
             ${constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.FONT_FAMILY}`;
            // fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.BOLD;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.KY_CO_DAU:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.KY_CO_DAU;
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PUBLISHER_INFO_WIDTH;
            fill = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PUBLISHER_INFO_FILL;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_CODE;
            defaultWidth =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_CODE_WIDTH;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_DATE;
            defaultWidth =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_DATE_WIDTH;
            fontSize =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_DATE_FONT_SIZE;
            fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC:
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PHU_LUC_WIDTH;
            fontSize = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PHU_LUC_FONT_SIZE;
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.PHU_LUC;
            fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.CHI_DAO:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CHI_DAO;
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.CHI_DAO_WIDTH;
            fill = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.CHI_DAO_FILL;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_Y:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.SAO_Y;
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.SAO_Y_WIDTH;
            fontSize =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.SAO_Y_FONT_SIZE;
            fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.NORMAL;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.SAO_LUC:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.SAO_LUC;
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.SAO_Y_WIDTH;
            fontSize =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.SAO_Y_FONT_SIZE;
            fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.NORMAL;
            break;
          case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.TRICH_SAO:
            shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.TRICH_SAO;
            defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.SAO_Y_WIDTH;
            fontSize =
              constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.SAO_Y_FONT_SIZE;
            fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.NORMAL;
            break;
          default:
            shapeType = null;
        }
        if (!configImg.codau) {
          this.$refs.detailDoc.addText({
            text: textImage.value,
            editable: true,
            shapeType: shapeType,
            defaultWidth: defaultWidth,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fill: fill,
            addWhiteBackground: addWhiteBackground
          });
        } else {
          this.$refs.detailDoc.addImage({
            url: configImg.urlImg,
            defaultWidth: 550,
            shapeType: shapeType,
          })
        }
      },

      // Get ID luồng đi của văn bản
      loadVbFlowInstance() {
        return vbFlowInstanceService
          .findCurrentOutgoingDocFlowInstance(this.docId)
          .then(response => (this.flowInstanceId = response.data.id));
      },

      validate() {
        if(this.isSignOriginalDoc) {
          return new Promise(resolve => {
            resolve(
              this.validateExistShape(
                constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_CODE,
                "signToken.error.missingDocCode"
              ) &&
              this.validateExistShape(
                constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_DATE,
                "signToken.error.missingDocDate"
              )
              // &&
              // (!this.listSignature ||
              //   !this.listSignature.length ||
              //   this.validateExistShape(
              //     constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CHU_KY,
              //     "signToken.error.missingSignature"
              //   )
              // )
            );
          });
        }
        // Validate cho van ban dinh kem va yeu cau ky token
        else {
          if(this.needToSignCa) {
            return new Promise(resolve => {
              resolve(
                this.validateExistShape(
                  constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.PHU_LUC,
                  "signToken.phuLuc.vbdinhkem.error"
                )
              );
            });
          } else {
            return Promise.resolve(true);
          }
        }
      },

      isExistsShapeWithShapeType(shapeType) {
        return h.exists(this.pagesData, pageData => {
          return (
            pageData.isPageModified &&
            h.exists(
              pageData.data.shapeOptionsData,
              shapeOptionsDataItem =>
                shapeOptionsDataItem.shapeOptions.shapeType === shapeType
            )
          );
        });
      },

      validateExistShape(shapeType, errorCode) {
        let isExists = this.isExistsShapeWithShapeType(shapeType);
        if (!isExists) {
          if (errorCode)
            this.message(
              "Thông báo",
              errorMessageFilter({errorCode: errorCode}),
              "error",
              2000
            );
          return false;
        }
        return true;
      },

      submitTest() {
        this.$refs.detailDoc.removeTransformer();
        this.isSubmitting = true;
        return this.savePageData()
          .then(() => {
            if (this.isKyNgoai) {
              return Promise.resolve(true)
                .then(isContinue => {
                  if (!isContinue) return;
                  let modifiedPagesData = h.collect(
                    h.findAll(this.pagesData, pageData => pageData.isPageModified),
                    pageData => {
                      return {
                        pageIndex: pageData.pageIndex,
                        pageImageData: pageData.pageImageData,
                        objectId: pageData.objectId,
                        isAttachmentDoc: pageData.isAttachmentDoc
                      };
                    }
                  );
                  this.$emit("submit", {pagesData: modifiedPagesData});
                });
            }

            else {
              return this.validate()
                .then(isPassValidate => {
                    if(this.isSignOriginalDoc) {
                      return !isPassValidate ? false : this.warningMissingStamp();
                    } else {
                      return isPassValidate;
                    }
                  }
                )
                .then(isContinue => {
                    if (this.isSignOriginalDoc) {
                      return !isContinue ? false : this.warningMissingLanhDaoNotes();
                    } else {
                      return isContinue;
                    }
                  }
                )
                .then(isContinue => {
                  if (!isContinue) return Promise.resolve(false);
                  let modifiedPagesData = h.collect(
                    h.findAll(this.pagesData, pageData => pageData.isPageModified),
                    pageData => {
                      return {
                        pageIndex: pageData.pageIndex,
                        pageImageData: pageData.pageImageData,
                        objectId: pageData.objectId,
                        isAttachmentDoc: pageData.isAttachmentDoc
                      };
                    }
                  );
                  this.$emit("submit", {
                    pagesData: modifiedPagesData
                  });

                  // Neu la ky token mobica thi restart lai pagesData sau moi lan chuyen van ban
                  // if(this.needToSignCa)
                  //   this.pagesData = [];
                });
            }
          })
          .then(result => {
            this.isSubmitting = false;
            return result;
          })
          .catch(error => {
            this.isSubmitting = false;
            throw error;
          });
      },

      waring_(options) {
        return new Promise(resolve => {
          if (options.checkFn()) {
            this.$confirm(options.buildConfirmMessageFn(), "Cảnh báo", {
              confirmButtonText: "Tiếp tục",
              cancelButtonText: options.buildCancelButtonTextFn(),
              type: "warning"
            })
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(false);
              });
          } else {
            resolve(true);
          }
        });
      },

      warningMissingStamp() {
        return this.waring_({
          checkFn: () => {
            return (
              this.listStamp &&
              this.listStamp.length &&
              !this.isExistsShapeWithShapeType(
                constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU
              )
            );
          },
          buildConfirmMessageFn: () =>
            errorMessageFilter({errorCode: "signToken.error.missingStamp"}),
          buildCancelButtonTextFn: () => "Thêm con dấu"
        });
      },

      /**
       * warning trong trường hợp thiếu ý kiến của lãnh đạo
       */
      warningMissingLanhDaoNotes() {
        return this.waring_({
          checkFn: () => {
            return (
              this.isShouldToInsertLanhDaoNotes &&
              !this.isExistsShapeWithShapeType(
                constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CHI_DAO
              )
            );
          },
          buildConfirmMessageFn: () =>
            errorMessageFilter({
              errorCode: "signToken.error.warningForLanhDaoNotes"
            }),
          buildCancelButtonTextFn: () => "Thêm ý kiến LĐ"
        });
      },

      generateTokenStamp() {
        if(this.flowInstanceId)
        {
          return attachmentService
            .getStampInfo(this.flowInstanceId)
            .then(res => (this.listAttachmentStamp = res.data));
        }
        else {
          if(this.$store.getters.userDeptRole.tenantCode === 'vinataba.com.vn') {
            return attachmentService
              .getListStampViaDocId(this.docId)
              .then(res => (this.listAttachmentStamp = res.data));
          }
        }
      },

      getListStampImage() {
        this.listStamp = [];
        if(this.isSignOriginalDoc) {
          return Promise.all(
            h.collect(this.listAttachmentStamp, stampInfoForm => {
              let department = stampInfoForm.department;
              let vbAttachment = stampInfoForm.vbAttachment;
              return vbAttachmentTokenService
                .getToken(vbAttachment.id)
                .then(res => {
                  this.listStamp.push({
                    url: buildAttachmentURL(res.data.token, {
                      type: constants.DOWNLOAD_OPTION.TYPE.STAMP
                    }),
                    department: department
                  });
                });
            })
          );
        } else {
          return Promise.resolve(true);
        }
      },

      generateTokenSignature() {
        if(this.flowInstanceId)
        {
          // if(this.$store.getters.userDeptRole.tenantCode === 'vinataba.com.vn'){
          //   return attachmentService
          //     .getListUserSigned(this.flowInstanceId)
          //     .then(res => (this.listAttachment = res.data));
          // }else{
          // }
          return attachmentService
            .getSignatures(this.flowInstanceId)
            .then(res => (this.listAttachment = res.data));
        }
        else {
          // if(this.$store.getters.userDeptRole.tenantCode === 'vinataba.com.vn') {
          //   return attachmentService
          //     .getListUserSignedViaDocId(this.docId)
          //     .then(res => (this.listAttachment = res.data));
          // }
          return attachmentService
              .getListUserSignedViaDocId(this.docId)
              .then(res => (this.listAttachment = res.data));
        }
      },

      getListSignatureImage() {
        this.listSignature = [];
        h.each(this.listAttachment, item => {
          let signature = {userDeptRoleView: item.userDeptRoleView};
          vbAttachmentTokenService.getToken(item.vbAttachment.id).then(res =>
            this.$set(
              signature,
              "url",
              buildAttachmentURL(res.data.token, {
                type: constants.DOWNLOAD_OPTION.TYPE.SIGNATURE
              })
            )
          );
          this.listSignature.push(signature);
        });
      },

      initToken() {
        this.getToken()
          .then(() => this.getPageSize())
          .then(() => this.downloadImageOriginal());
      },

      getPageSize() {
        let promise = null;
        if( this.isSignOriginalDoc ) {
          promise = attachmentService
            .getPageSize(this.vbAttachmentId)
            .then(response => (this.pageSize = response.data.pageSize))
            .catch(() => (this.pageSize = 0));
        } else {
          promise = attachmentService
            .getPageSize(this.relationDocId, true)
            .then(response => (this.pageSize = response.data.pageSize))
            .catch(() => (this.pageSize = 0));
        }
        return promise;
      },

      changeImg(obj) {
        let index = this.listImages.findIndex(item => item.url === obj.url);
        this.$set(this.listImages[index], "uri", obj.uri);
        this.$set(this.listImages[index], "isModify", true);
      },

      getToken() {
        let promise = null;

        // Get token cho văn bản chính
        if( this.isSignOriginalDoc ) {
          promise = vbAttachmentTokenService
            .getToken(this.vbAttachmentId)
            .then(response => (this.token = response.data.token));
        }
        // Get token cho văn bản đính kèm
        else {
          promise = vbAttachmentTokenService
            .getTokenDocRelation(this.relationDocId)
            .then(response => (this.token = response.data.token));
        }
        return promise;
      },

      downloadImageOriginal() {
        this.listImages = [];
        for (let i = 0; i < this.pageSize; i++) {
          this.listImages.push({
            id: i,
            url: buildAttachmentImage(this.token, {
              type: constants.DOWNLOAD_OPTION.TYPE.IMAGE,
              imageStatus: "original",
              pageNumber: i
            })
          });
        }
        this.$nextTick(() => {
          this.changeSelectedDoc(this.listImages[0], 0, true);
        });
      },

      changeSelectedDoc(page, pageIndex, isChangeDoc) {
        if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc) return;
        this.$refs.detailDoc.removeTransformer();
        this.isChangingSelectedDoc = true;

        let promiseResult = null;
        if( !isChangeDoc && this.selectedPageIndex !== pageIndex)
          promiseResult = this.savePageData();
        else
          promiseResult = Promise.resolve(null)

        return promiseResult
          .then(() => {
            this.urlDocSelected = page;
            this.selectedPageIndex = pageIndex;
            let objectId = this.isSignOriginalDoc ? this.docId : this.relationDocId;
            let pageData = this.getPageData(objectId, pageIndex);
            return this.$refs.detailDoc.loadPage({
              backgroundURL: this.urlDocSelected.url,
              pageData: pageData ? pageData.data : null
            });
          })
          .then(result => {
            this.isChangingSelectedDoc = false;
            return result;
          });
      },

      savePageData() {
        // Neu khong co trang duoc chon
        if (this.selectedPageIndex == null) return Promise.resolve(null);
        let isPageModified = this.$refs.detailDoc.isPageModified();
        return (isPageModified
            ? this.$refs.detailDoc.getPageImageData()
            : Promise.resolve(null)
        ).then(pageImageData => {
          if (!pageImageData) return Promise.resolve(null);
          let objectId = this.isSignOriginalDoc ? this.docId : this.relationDocId;
          let pageData = this.getPageData(objectId, this.selectedPageIndex);
          if (!pageData)
            this.pagesData.push(
              (pageData = {
                pageIndex: this.selectedPageIndex,
                objectId: this.isSignOriginalDoc ? this.docId : this.relationDocId,
                isAttachmentDoc: this.isSignOriginalDoc
              })
            );
          pageData.data = isPageModified
            ? this.$refs.detailDoc.getPageData()
            : null;
          pageData.pageImageData = pageImageData;
          pageData.isPageModified = isPageModified;
        });
      },

      getPageData(objectId, pageIndex) {
        return h.find(
          this.pagesData,
          pageData => pageData.pageIndex === pageIndex && pageData.objectId === objectId
        );
      },

      addImageSignature(item, shapeType) {
        if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc) return;
        this.$refs.detailDoc.addImage({
          url: item.url,
          shapeType: shapeType,
          defaultWidth: 250
        });
      },

      addQRCodeSignature() {
        if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc) return;
        const canvas = this.$refs.qrCode.$el.querySelector('canvas');
        const base64String = canvas.toDataURL('image/png');
        console.log('Base64 string:', base64String);
        this.$refs.detailDoc.addBase64(base64String);
      },

      addImageStamp(item, shapeType) {
        if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc) return;
        this.$refs.detailDoc.addImage({
          url: item.url,
          fixedWidth: constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.STAMP_FIXED_WIDHT,
          shapeType: shapeType
        });
        console.log(item)
      },

      addLogo(item, shapeType) {
        if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc) return;
        this.$refs.detailDoc.addImage({
          url: item.url,
          defaultWidth: 100,
          defaultHeight: 100,
          shapeType: shapeType
        });
        console.log(item)
      },
      addImageToTT(item){
        // (item)
        function toDataURL(url, callback) {
          var xhr = new XMLHttpRequest();
          xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
              callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
        }

        toDataURL(item.url, function(dataUrl) {
          document.querySelector('#imgChuKy').src = dataUrl;
        })

      },

      async getTokenOutgoingDoc() {
        if(this.docId) {
          // const dataRes = await vbAttachmentTokenService.getTokenOutgoingAttachment(this.docId);
          this.valueQrCode = null;
          const postUrl = constants.QR_CODE_BAO_THANH_TRA
          const data = {
            file_url: constants.BASE_SERVICE_URL +
            "vbAttachmentToken/downloadFilePublic?docId=" + this.docId + "&type=pdf" + "&tenantCode=" + this.$store.getters.userDeptRole.tenantCode
          }

          const config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization':  constants.CMS_API_KEY
            }
          }
          const res = await axios.post(postUrl, data, config).catch(error => {
            console.log("=>(ky-token-dialog.vue:1097) error", error);
          });
          this.valueQrCode = res.data.return_url
        }
      },
    },

  };
</script>

<style lang="css">
  .pListThumb {
    max-height: calc(100vh - 100px);
    height: auto;
  }

  .scrollSignature .pListThumb-Title {
    color: var(--color-blue);
  }

  .pListThumb-Title {
    margin-bottom: 12px;
  }

  .pScroll {
    max-height: calc(100vh - 160px);
    height: auto;
    margin-top: 22px;
    /* margin-bottom: 10px; */
  }

  .pScroll.scrollSignature {
    margin-top: 58px;
    max-height: calc(100vh - 163px);
  }

  .pScroll.scrollWatchingNote {
    max-height: calc(100vh - 206px);
  }

  .pThumb {
    max-width: calc(100% - 10px);
    height: 100%;
    max-height: 350px;
    margin-bottom: 10px;
    border-radius: 8px;
    border: 1px solid #ceced2;
    position: relative;
    transition: all 0.25s ease-in-out;
  }

  .pThumb.active {
    border: 2px solid #007aff;
    transition: all 0.25s ease-in-out;
  }

  .pThumb .markIsModified.off {
    visibility: hidden;
  }

  .pThumb .markIsModified.on {
    visibility: visible;
  }

  .pThumb .markIsModified {
    position: absolute;
    width: 12px;
    height: 12px;
    flex: 0 0 auto;
    background-color: #e54d42;
    top: 3px;
    right: 3px;
    border-radius: 50%;
  }

  .pThumb .pBgThumb {
    max-width: 90%;
    width: 100%;
    height: 150px;
    margin: 0 10px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .pThumb .pIndex {
    position: absolute;
    width: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgb(255, 255, 255)
    );
    height: 60px;
    bottom: 0;
    z-index: 0;
    border-radius: 0 0 8px 8px;
    padding: 0 10px;
    padding-bottom: 10px;
    align-items: flex-end;
    justify-content: center;
    color: #2d3e4f;
  }

  .pDetailDocs {
    max-height: calc(100vh - 100px);
    height: auto;
  }

  .pControl {
    padding: 10px 0;
    height: 56px;
  }

  .pDetail {
    max-height: calc(100vh - 100px);
    height: auto;
  }

  .pScrollDoc {
    max-height: calc(100vh - 165px);
    height: auto;
    border: 1px solid #abb4bd;
    border-bottom-color: transparent;
    border-radius: 8px 0 0 0;
  }

  .pScrollDoc.pWatchingNote {
    margin-top: 56px;
  }

  .page-center > div {
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: calc(100vh - 140px);
    height: calc(100vh - 140px);
    position: relative;
  }

  .BtnEdit {
    background-color: #efeff4;
    border: 1px solid red;
    font-size: 18px;
  }

  .BtnEdit.el-button.is-disabled {
    border: 1px solid red;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/ky-token-dialog.vue